module.exports = __webpack_public_path__ + "static/media/LightBlue-P.6578d27d.png";